import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import styles from '../Option.module.css';
import HighlightText from 'components/UI/Inputs/AIQAutocomplete/HighlightText';

// Hoisted: see Section.jsx. EquipmentField is rendered up to ~8 times per row.
const FIELD_SX = { display: 'inline-flex', alignItems: 'center' };
const VALUE_STYLE = { marginLeft: '4px' };

const EquipmentField = ({ label, value, searchTerm }) => (
    <Typography component="span" fontSize="0.7rem" sx={FIELD_SX}>
        <span className={styles.title}>{label}:</span>
        <span className={styles.value} style={VALUE_STYLE}>
            <HighlightText text={String(value ?? '')} searchTerm={searchTerm} />
        </span>
    </Typography>
);

EquipmentField.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    searchTerm: PropTypes.string,
};

export default EquipmentField;
